var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow31(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38501)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_38501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2119 36.2776V31.4043L25.7606 41.7743V46.591L14.2119 36.2776Z",
    fill: "#24478F",
    stroke: "black",
    strokeWidth: 0.548523,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7734 41.7861L41.5268 37.9668V42.8628L25.7734 46.6595V41.7861Z",
    fill: "#2E5CB8",
    stroke: "black",
    strokeWidth: 0.548523,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5381 37.9682V42.8642L45.7541 28.6976V23.8242L41.5381 37.9682Z",
    fill: "#193366",
    stroke: "black",
    strokeWidth: 0.548523,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2156 13.4531L45.753 23.8231L41.537 37.9671L25.761 41.7638L14.2236 31.4051L18.4396 17.2498L34.2156 13.4531ZM33.819 21.6811C37.4456 23.5738 38.6923 27.7558 36.5843 31.0311C34.499 34.2951 29.8296 35.4171 26.1803 33.5245C22.5536 31.6545 21.307 27.4498 23.415 24.1858C25.489 20.9105 30.147 19.7771 33.8076 21.6698L33.819 21.6811Z",
    fill: "#8DA6D8",
    stroke: "black",
    strokeWidth: 0.548523,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6901 29.5462C22.3923 28.6592 22.2988 27.7163 22.4166 26.7881C22.5343 25.8598 22.8603 24.9702 23.3701 24.1856C25.5235 20.8989 30.1701 19.7656 33.7968 21.6922C36.9135 23.3129 38.2848 26.6109 37.2761 29.5689C36.6805 27.8457 35.4363 26.4227 33.8081 25.6022C30.1815 23.7889 25.5348 24.8089 23.3815 28.1182C23.0959 28.5719 22.8675 29.0592 22.7015 29.5689L22.6901 29.5462Z",
    fill: "url(#paint0_linear_1322_38501)",
    stroke: "black",
    strokeWidth: 0.548523,
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1322_38501",
    x1: 20.1401,
    y1: 16.7396,
    x2: 20.1401,
    y2: 35.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5CB8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_38501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow31);
export default __webpack_public_path__ + "static/media/row-3-1.36df28802d553e898f6f6a992ead2f42.svg";
export { ForwardRef as ReactComponent };